import React from 'react';
import { Receipt as ReceiptIcon } from "@mui/icons-material";
import TimeFields from '../../../Components/Fields/TimeFields';
import FormDate from '../../../Components/FormFields/FormDate';
import MultiDatePicker from '../../MultiDatePicker';
import DurationFields from '../../../Components/Fields/DurationFields';
import FormInput from '../../../Components/Ui/FormInput';
import AlertInfo from '../../AlertInfo';
import { useTailwindBrand } from '../../../Components/shared';
import {  getActiveClientBrandConfig, getActivePrestationBrandConfig, isDepositEnabled } from '../../../config/environment.config';

interface Props {
    errorPrice?: boolean
    msgErrorPrice?: string
    errorDates?: boolean
    errorEndTime?: boolean
    msgErrorDates?: string
    msgErrorEndTime?: string
    setStartTime: React.Dispatch<any>
    setEndTime: React.Dispatch<any>
    setDatesValues?: React.Dispatch<any>
    startTime?: any
    dateTime?: any
    valueDate?: any
    duration: number
    setDate: (value: string) => void
    defaultResult?: any
    customDuration?: string
    valueDuration?: any
    isPunctualMonth?: boolean
    setDuration: ((value: number) => void) | ((currentValue: number) => number) | any
    setTeachrPrice: (value: string) => void
    price?: any
    customPrice?: string | undefined
    customBody?: string
    customAll?: string
    customErrorBody?: string
    customMultiDatePicker?: string
    inputChild?: any
    startAt?: any
    setDesposit?: (value: string) => void
    deposit?: number
    depositStay?: number | string
    customDeposit?: string | undefined
    customDepositStay?: string | undefined
    amount?: number
    proof?: React.ReactNode
    displayTerms?: React.ReactNode
    errorDate?: boolean
    errorMsgDate?: string
    depositDate?: string | Date
    setDepositDate?: (value: string) => void
    errorDepositDate?: boolean
    isTeachrContact?: boolean
    errorDepositMsg?: string
    setIsOver?: any
    errorMsgMonth?: any
    proofDeposit?: string;
    proofDeposits?: string[];
    isCoursePass?: boolean
    errorMsgDeposit?: string
    errorDeposit?: boolean
    isProof?: boolean
    conditionScoop?: boolean
    /** P1 – formulaire multi-séances (cours mensuel) : remplace MultiDatePicker + durée globale. */
    sessionList?: React.ReactNode

    // amountDuration?: (duration: number) => number
}

const FormEditCourse = (props: Props) => {
    const { classes } = useTailwindBrand()

    return (
        <div className={` ${props.customAll}`}>
            <div className={`${props.customErrorBody}`}>
                {props.errorEndTime ? <strong className={`${classes.error} ${classes.fontFamily}  lg:text-base italic`}>{props.msgErrorEndTime}</strong> : ""}
            </div>
            <div className={`${props.customBody} /pb-2`}>
                {props.inputChild}
                {!props.isPunctualMonth ?
                    <>
                        <TimeFields
                            value={props.startTime}
                            date={props.dateTime}
                            setEndTime={props.setEndTime}
                            setStartTime={props.setStartTime}
                            duration={props.duration}
                            startAt={props.startAt}
                            setIsOver={props.setIsOver}
                            label={`Heure de ${getActivePrestationBrandConfig("", "", "la ")}`}
                        />
                        <FormDate
                            defaultValue={props.valueDate}
                            callback={props.setDate}
                            label={`Jour  ${getActivePrestationBrandConfig("", "du ", "de la ")}`}
                            error={props.errorDate ? props.errorMsgDate : undefined}
                            minDate={props.startAt}
                        />
                    </> :
                    (props.sessionList ??
                        <MultiDatePicker
                            startAt={props.startAt}
                            customMultiDatePicker={props.customMultiDatePicker}
                            defaultValue={props.defaultResult}
                            setStartDate={props.setStartTime}
                            setEndDate={props.setEndTime}
                            setDatesValues={props.setDatesValues}
                            setIsOver={props.setIsOver}
                            customMultiDate='rmdp-mobile'
                            customMobileLabels={{
                                OK: "Ok",
                                CANCEL: "Fermer",
                            }}
                            label={`La période des  ${getActivePrestationBrandConfig("s")}`}
                            error={props.errorDates}
                            errorMsg={props.msgErrorDates}
                        />
                    )
                }
                {/* P1 – la durée d'un mensuel est saisie séance par séance dans sessionList */}
                {!(props.isPunctualMonth && props.sessionList) &&
                    <DurationFields
                        customDuration={props.customDuration}
                        value={props.valueDuration}
                        isPunctualMonth={props.isPunctualMonth}
                        duration={props.duration}
                        setDuration={props.setDuration}
                        setEndTime={props.setEndTime}
                        startTime={props.startTime}
                        label={`Durée de ${getActivePrestationBrandConfig("", "", "la ")}`}
                    />
                }
                <FormInput
                    label="Prix horaire payé"
                    value={props?.price}
                    onChange={(e) => props.setTeachrPrice(e.target.value)}
                    type="number"
                    placeholder='Ex : 5'
                    className={`${props.customPrice} text-left`}
                    error={props.errorPrice ? props.msgErrorPrice : undefined}
                />

                {!props.conditionScoop &&
                    props.isTeachrContact ? <FormInput
                    label={`Montant total déjà réglé par ${getActiveClientBrandConfig('', "l'", "le ")}`}
                    value={isNaN(props?.deposit!) ? 0 : props?.deposit}
                    onChange={(e) => props.setDesposit && props.setDesposit(e.target.value)}
                    type="number"
                    placeholder='Ex : 5'
                        className={`text-left ${props.customDepositStay}`}
                    error={props.errorDeposit ? props.errorMsgDeposit : undefined}
                
                /> : ''}
                {!props.deposit || !isDepositEnabled() ? "" :
                    <>
                        <FormInput
                            label={`Reste à charge pour votre ${getActiveClientBrandConfig()}`}
                            value={props?.depositStay}
                            type="number"
                            placeholder='Ex : 5'
                            className={`text-left ${props.customDeposit}`}
                            disabled={true}
                        />
                        <FormDate
                            defaultValue={props.depositDate as string | Date}
                            callback={props?.setDepositDate}
                            label="Date d'acompte"
                            error={props.errorDepositDate ? props.errorDepositMsg : undefined}
                        />
                        {props.proofDeposits && props.proofDeposits.length > 0 && props.isProof && !props?.isCoursePass ? (
                            <div className={`flex items-start gap-3 px-1 border rounded-md border-gray-400`}>
                                <ReceiptIcon className="w-5 h-5 flex-shrink-0 mt-1" />
                                <div className="flex-1">
                                    <dt className={`md:text-base text-sm font-bold -mb-1 ${classes.fontFamily}`}>Preuves d'acompte</dt>
                                    <dd className={`md:text-base text-sm flex flex-col ${classes.fontFamily}`}>
                                        {props.proofDeposits.map((url: string, index: number) => (  
                                            <a
                                                key={index}
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`underline font-medium md:/text-base text-sm ${classes.fontFamily}`}
                                            >
                                                Visualiser la preuve d'acompte {index + 1}
                                            </a>
                                        ))}
                                    </dd>
                                </div>
                            </div>
                        ) : props.proofDeposit && props.isProof && !props?.isCoursePass && (
                            <>
                                <div className={`flex items-center gap-3 px-1 border rounded-md border-gray-400`}>
                                    <ReceiptIcon className="w-5 h-5  flex-shrink-0" />
                                    <div className="flex-1">
                                        <dt className={`md:text-base text-sm font-bold -mb-1 ${classes.fontFamily}`}>Preuve d'acompte</dt>
                                        <dd className={`md:text-base text-sm ${classes.fontFamily}`}>
                                            <a
                                                href={props.proofDeposit}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`underline font-medium md:/text-base text-sm ${classes.fontFamily}`}
                                            >
                                                Visualiser la preuve d'acompte
                                            </a>
                                        </dd>
                                    </div>
                                </div>
                            </>
                        )}
                    </>}
            </div>
            {props.errorMsgMonth}
            {
                (props?.deposit && props.amount && isDepositEnabled()) ?
                    (
                        <div className="">
                            {props?.amount < props.deposit && <strong className={`lg:text-base text-sm text-[#FF724F]  ${classes.fontFamily} italic`}>Le montant déjà réglé doit être au maximum {props.amount} </strong>}
                            <AlertInfo
                                msg={
                                    <div className={`${classes.text} ${classes.fontFamily} text-left`}>
                                        <li>{getActivePrestationBrandConfig("", "Ce ", "Cette ")} revient donc à <strong className={` ${classes.primaryText}`}>{(props.amount).toFixed(2) ?? 0}€ </strong> grâce à l’Avance Immédiate pour votre {getActiveClientBrandConfig()}. </li>
                                        <li> Le reste à charge qui sera prélevé sur le compte de votre {getActiveClientBrandConfig()} est de <strong className={` ${classes.primaryText}`}>{props?.depositStay ?? 0}€</strong> suite à l’acompte déjà versé par celui-ci.</li>
                                    </div>
                                }
                                info="info"
                                customClass=""
                            />
                            {props.displayTerms}
                        </div>
                    ) : ""
            }
            {props?.proof ? props.proof : ""}
            { }
        </div>
    )
};

export default FormEditCourse;